import CoinSVG from "@/assets/svg/adcelerate/coin.svg";
import GlobeSVG from "@/assets/svg/adcelerate/globe.svg";
import Pattern from "@/assets/svg/adcelerate/pattern.svg";
import SparkleSVG from "@/assets/svg/adcelerate/sparkle.svg";
import Button from "@/components/ui/button";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import scrollTo from "@/utils/scrollTo";
import { ArrowDownRight } from "lucide-react";

export default function OurExpertise() {
  const { ref, isVisible } = useScrollReveal();

  const benefits = [
    {
      icon: SparkleSVG,
      title: "Zero Cost. Zero Effort.",
      description:
        "Adcelerate makes it simple for creators to publish and monetize their content. Getting started is fast, safe, and free—just connect your account and our team will manage the rest, allowing you to focus entirely on creating.",
    },
    {
      icon: GlobeSVG,
      title: "Reach 2B+ Viewers Worldwide",
      description:
        "Your content is published directly across platforms like MSN, YouTube, Facebook, TikTok, BiliBili, and more, giving you instant reach to global audiences.",
    },
    {
      icon: CoinSVG,
      title: "Instant Earnings",
      description:
        "No minimums. No delays. The moment your videos go live, they start generating revenue.",
    },
  ];

  return (
    <div
      ref={ref}
      id="features"
      className={`${
        isVisible ? "bounce-up" : ""
      } flex flex-col lg:flex-row justify-between py-16 lg:py-0 lg:px-20 items-center gap-10 lg:gap-16 xl:gap-20 4xl:max-w-[100rem] 4xl:mx-auto bg-black lg:h-screen 4xl:h-[60vh] relative overflow-hidden pb-60 lg:pb-0`}
    >
      <div className="space-y-8 lg:space-y-6 xl:space-y-8 text-left lg:w-[50%] xl:w-[38%] text-lg px-12 lg:px-0 z-50">
        <p className="text-primary font-medium">Our Expertise</p>
        <div className="flip-wrapper">
          <h1 className="text-white text-left text-4xl lg:text-5xl 1xl:text-6xl font-bold adce-hero">
            {"Share your content, we’ll do the rest"
              .split("")
              .map((char, i) => (
                <span
                  key={i}
                  className="inline-block flip-letter"
                  style={{ animationDelay: `${i * 0.05}s` }}
                >
                  {char === " " ? "\u00A0" : char}
                </span>
              ))}
          </h1>
        </div>
        <p className="text-white">
          From optimizing placements to building connections with the right
          platforms and advertisers, we bring years of expertise in digital
          rights management and content monetization.
        </p>
        <Button
          className="bg-primary text-white rounded-md w-48 py-6 !mt-8 lg:!mt-10 xl:!mt-14"
          onClick={() => scrollTo("partners")}
        >
          Our partners <ArrowDownRight />
        </Button>
      </div>
      <div className="flex justify-end items-center w-[90%] lg:w-[50%] xl:w-[40%]">
        <div className="relative h-96 lg:h-screen 4xl:h-[60vh] overflow-hidden w-full">
          <div className="scroll-wrapper-vertical">
            <div className="scroll-track-vertical">
              {[...Array(5)].map((_, dup) => (
                <div key={dup}>
                  {benefits.map((benefit, idx) => (
                    <div
                      key={idx}
                      className="w-full bg-[#0B69A6]/30 rounded-[20px] p-8 flex flex-col items-start mb-10"
                    >
                      <img
                        src={benefit.icon}
                        className="w-16 h-16"
                        alt="Icon"
                      />
                      <div className="space-y-3">
                        <h1 className="text-primaryLight text-lg font-medium">
                          {benefit.title}
                        </h1>
                        <p className="text-white">{benefit.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="absolute lg:-left-[250px] -bottom-36 md:-bottom-[440px] lg:-bottom-[500px] max-w-[800px] z-0">
        <img src={Pattern} className="animate-spin-slow" alt="Pattern" />
      </div>
    </div>
  );
}
